import { http } from "./http";

export type TipoGrupoInvitados = "FAMILIA" | "AMIGOS" | "INVITADOS_ESPECIALES";

export type Asistente = {
  id: number;
  nombre: string;
  apellido: string;
  telefono: string | null;
  email: string | null;
  esPrincipal: boolean;
  relacion: "PRINCIPAL" | "OTRO";
};

export type GrupoInvitados = {
  id: number;
  eventoId: number;
  nombreGrupo: string;
  tipo: TipoGrupoInvitados;
  adicionalesCantidad: number;
  maxInvitados: number;
  cupoTotal: number;
  creadoEn: string;
  tokenPublico: string;
  publicUrl: string;
  principal: Asistente;
  asistentes: Asistente[];
};

export type CreateAsistenteRequest = {
  nombre: string;
  apellido: string;
  telefono?: string;
  email?: string;
  esPrincipal: boolean;
};

export type UpdateInvitadoRequest = {
  nombre: string;
  apellido: string;
  telefono: string;
  email?: string;
};

export type CreateGrupoInvitadosRequest = {
  eventoId: number;
  nombreGrupo: string;
  tipo: TipoGrupoInvitados;
  maxInvitados: number;
  adicionalesCantidad: number;
  asistentes: CreateAsistenteRequest[];
};

export async function listarGruposInvitadosPorEvento(eventoId: number) {
  return http.request<GrupoInvitados[]>(`/api/admin/grupos-invitados/evento/${eventoId}`, {
    method: "GET",
  });
}

export async function crearGrupoInvitados(payload: CreateGrupoInvitadosRequest) {
  return http.request<GrupoInvitados>(`/api/admin/grupos-invitados`, {
    method: "POST",
    body: payload,
  });
}

export async function actualizarInvitado(invitadoId: number, payload: UpdateInvitadoRequest) {
  return http.request<Asistente>(`/api/admin/invitados/${invitadoId}`, {
    method: "PUT",
    body: payload,
  });
}

export async function eliminarInvitado(invitadoId: number) {
  await http.request<void>(`/api/admin/invitados/${invitadoId}`, {
    method: "DELETE",
  });
}
